import classNames from 'classnames';
import {
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { AlertNotificationProps } from './types';

const iconByVariant = {
  danger: faExclamationCircle,
  info: faInfoCircle,
  warning: faExclamationTriangle,
};

export const AlertNotification = ({
  variant = 'info', title, message, className = '',
}: AlertNotificationProps) => (
  <div
    role="alert"
    className={classNames(
      'catalog-alert-notification',
      `catalog-alert-notification--${variant}`,
      className,
    )}
  >
    <span className="catalog-alert-notification__icon" aria-hidden="true">
      <FontAwesomeIcon icon={iconByVariant[variant]} />
    </span>
    <div className="catalog-alert-notification__content">
      <div className="catalog-alert-notification__title">{title}</div>
      <div className="catalog-alert-notification__message">
        {typeof message === 'string' ? <p>{message}</p> : message}
      </div>
    </div>
  </div>
);
